<template>
  <lay-row>
    <lay-col md="24">
      <div style="padding: 10px;">
        <lay-table :columns="columns" :data-source="dataSource" :page="page" @change="events" height="700px" >
          <template #station="{row}">
            {{row.station + 'ES'}}
          </template>
          <template #type>
            遥信变位
          </template>
          <template #status="{row}">
            <lay-tag v-if="row.status == 0" type="danger" size="xs" shape="round">未读</lay-tag>
            <lay-tag v-else type="normal" size="xs"  shape="round">已读</lay-tag>
          </template>
          <template #operation="{row}">
            <lay-button prefix-icon="layui-icon-ok-circle" size="xs"  radius border-style="dashed" plain border="green" style="padding: 0 15px;" v-if="row.status == 0" @click="readEvent(row.id)">确认</lay-button>
          </template>
          <template #page>
            <lay-button prefix-icon="layui-icon-ok-circle" size="xs"  radius border-style="dashed" plain border="green" style="padding: 0 15px;" @click="readEvent(-1)">一键确认</lay-button>
          </template>
        </lay-table>
      </div>
    </lay-col>
  </lay-row>
</template>

<script setup>
import {ref} from "vue";
import axios from "axios";
import { layer } from "@layui/layui-vue";
import useUtils from "@/assets/js/utils";

const columns = [
  {
    title:"记录时间",
    width:"100px",
    key:"time"
  },{
    title:"配电站",
    width:"100px",
    key:"station",
    customSlot: "station",
  },{
    title:"事件类型",
    width: "80px",
    key:"type",
    customSlot: "type",
  },{
    title:"描述",
    width: "220px",
    key:"detail",
    ellipsisTooltip: true,
  },{
    title:"事件信息",
    width: "130px",
    key:"info",
    ellipsisTooltip: true,
  },{
    title:"状态",
    width: "110px",
    key:"status",
    customSlot: "status",
  },{
    title:"操作",
    width: "110px",
    customSlot: "operation",
  }
]

const dataSource = ref([])
let {falseAlert} = useUtils();
const page = ref({
  total: 1,
  limit: 20,
  current: 1,
  showRefresh: true,
})

function events(){
  axios.get(`/event/list?pageNum=${page.value.current}&pageSize=${page.value.limit}&start=2026-01-01&end=2030-01-01`)
      .then(function (response) {
        if (response.data.code == 0){
          dataSource.value = response.data.data.list;
          page.value.total = response.data.data.total;
        }
      })
}
function readEvent(id){

  layer.confirm(id == - 1 ? "一键确认所有未读消息？" : "确认未读消息？",
      {
        title: '确认提示',
        btn: [
          {text:'确认', callback: (layer_id) => {
              axios.get(`/event/read?id=${id}`) .then(function (response) {
                if (response.data.code == 0){
                  if (id == -1){
                    falseAlert(); //提示栏报警消除
                  }
                  events()
                }
              }).finally(() => {
                setTimeout(() => {
                  layer.close(layer_id);
                }, 200)
              })
            }
          },
          {text:'取消', callback: (layer_id) => {
              layer.msg("已取消");
              layer.close(layer_id);
            }
          }
        ]
      }
  );

}
events()


</script>

<style scoped>

</style>